export default __webpack_public_path__ + "static/media/skovstykket-property-06.1d8ee8d8.jpg";